import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface RightPanelGradientBackgroundProps {
  children: ReactNode;
  className?: string;
}

export const RightPanelGradientBackground = ({
  children,
  className,
}: RightPanelGradientBackgroundProps) => (
  <div
    className={classNames(
      "size-full items-center justify-center rounded-xl lg:flex",
      className,
    )}
    style={{
      background: `
        radial-gradient(circle at top left, #4855bf 0%, rgba(28, 17, 68, 0) 40%),
        radial-gradient(circle at bottom right, #2c256f 0%, rgba(28, 17, 68, 0) 20%),
        linear-gradient(to bottom, #180e3a, #211450)
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    {children}
  </div>
);
